import { InjectionToken } from "@angular/core";

export const CUSTOM_HTTP_INTERCEPTOR_REDIRECT_TOKEN = new InjectionToken<string>("unauthorizedRedirectUrl");
